export default __webpack_public_path__ + "static/media/white-close-modal-icon.3de87069.svg";